import { render, staticRenderFns } from "./PageBIEmitters.vue?vue&type=template&id=79ad59a8"
import script from "./PageBIEmitters.vue?vue&type=script&lang=js"
export * from "./PageBIEmitters.vue?vue&type=script&lang=js"
import style0 from "./PageBIEmitters.vue?vue&type=style&index=0&id=79ad59a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports